import $ from 'jquery';

// Open search bar
$( '.js-open-search-bar' ).on('click', function(e) {
	e.preventDefault();
	$( this ).parent().addClass( 'c-search-bar--is-open' );
	$( '.c-search-bar__input' ).focus();
} );

// Close search bar when clicking outside
$( document ).on( 'click', function( e ) {
	if ( $( '.c-search-bar' ).hasClass( 'c-search-bar--is-open' ) && $( e.target ).is( '.c-search-bar__toggle, .c-search-bar__input' ) === false ) {
		$( '.c-search-bar' ).removeClass( 'c-search-bar--is-open' );
	}
} );
